import React from 'react'
import { __ } from '@wordpress/i18n';
import {
        Popover, SelectControl,__experimentalHStack as HStack,
        __experimentalVStack as VStack,
        __experimentalText as Text,  Button,
        __experimentalToolsPanelItem as ToolsPanelItem} from '@wordpress/components';
import { ControlPanelControl } from '@vayu-blocks';

const mask_shapeoptions = [
    { label: __('Mask Shape', 'vayu-blocks'), value: 'none' },
    { label: __('Circle', 'vayu-blocks'), value: 'circle' },
    { label: __('Diamond', 'vayu-blocks'), value: 'diamond' },
    { label: __('Hexagone', 'vayu-blocks'), value: 'hexagone' },
    { label: __('Rounded', 'vayu-blocks'), value: 'rounded' },
    { label: __('Mask 1', 'vayu-blocks'), value: 'bob1' },
    { label: __('Mask 2', 'vayu-blocks'), value: 'bob2' },
    { label: __('Mask 3', 'vayu-blocks'), value: 'bob3' },
    { label: __('Mask 4', 'vayu-blocks'), value: 'bob4' },
];

export const Mask = ({maskPopoverAnchor,setismaskVisible,animationData,dataKey, onChange}) => {

    const handleMaskAnimationSize = (animation) => {
        const updatedAnimationData = {
            ...animationData,
            mask: { ...animationData.mask, masksize: animation },
        };
        onChange(dataKey, updatedAnimationData);
    };
    
    const handleMaskAnimationPosition = (animation) => {
        const updatedAnimationData = {
            ...animationData,
            mask: { ...animationData.mask, maskposition: animation },
        };
        onChange(dataKey, updatedAnimationData);
    };
    
    const handleMaskAnimationRepeat = (animation) => {
        const updatedAnimationData = {
            ...animationData,
            mask: { ...animationData.mask, maskrepeat: animation },
        };
        onChange(dataKey, updatedAnimationData);
    };
    
    const handleMaskAnimationClick = (animation) => {
        const updatedAnimationData = {
            ...animationData,
            mask: { ...animationData.mask, maskshape: animation },
        };
        onChange(dataKey, updatedAnimationData);
    };    

    const getmaskImagePath = (value) => {
        let svg;
        
        switch (value) {
            case 'circle':
                svg = `<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 480 380" xml:space="preserve">
                            <circle cx="240" cy="190" r="184"/>
                        </svg>`;
                break;
            case 'diamond':
                svg = `<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 480 380" xml:space="preserve">
                            <rect x="106.001" y="56.001" transform="matrix(-0.7071 -0.7071 0.7071 -0.7071 275.3553 494.0559)" width="267.998" height="267.999"/>
                        </svg>`;
                break;
            case 'hexagone':
                svg = `<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 480 380" xml:space="preserve">
                            <polygon points="79.386,97.269 240,4.538 400.614,97.269 400.614,282.73 240,375.462 79.386,282.73"/>
                        </svg>`;
                break;
            case 'rounded':
                svg = `<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 480 380" xml:space="preserve">
                            <path d="M421,309.436C421,343.437,393.437,371,359.436,371H120.564C86.563,371,59,343.437,59,309.436V70.564  
                                    C59,36.563,86.563,9,120.564,9h238.871C393.437,9,421,36.563,421,70.564V309.436z"/>
                        </svg>`;
                break;
            case 'bob1':
                svg = `<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 480 380" xml:space="preserve">
                            <path d="M47.846,184.442c-87.942,134.709,80.073,196.702,186.331,196.702c104.494,0,222.582-39.417,222.582-160.557  
                                    C456.758-91.25,198.783-46.776,47.846,184.442z"/>
                        </svg>`;
                break;
            case 'bob2':
                svg = `<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 480 380" xml:space="preserve">
                            <path d="M393.879,31.896c96.935,41.811,41.553,265.103-29.118,320.414c-74.443,58.259-320.428,32.36-330.586-185.032  
                                    C29.551,68.561,183.588-58.822,393.879,31.896z"/>
                        </svg>`;
                break;
            case 'bob3':
                svg = `<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 480 380" xml:space="preserve">
                            <path d="M141.699,9.958c37.611-41.211,253.977,90.988,263.995,181.115c10.016,90.134-215.692,232.896-280.453,172.106
                                    C69.045,310.428,39.531,121.932,141.699,9.958z"/>
                        </svg>`;
                break;
            case 'bob4':
                svg = `<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 480 380" xml:space="preserve">
                            <g>
                                <path d="M69.19,26.334C54.496,39.876,42.91,57.185,35.302,75.221c-10.718,25.408-15.268,52.962-18.384,80.363
                                        c-10.069,88.57,17.375,190.72,112.557,217.96c63.844,18.273,133.074-0.437,191.492-27.517
                                        c85.828-39.789,206.786-163.646,105.685-255.719C372.3,40.81,284.499,59.485,220.248,32.528
                                        c-30.103-12.63-58.445-35.896-92.778-33.125C105.078,1.21,85.272,11.517,69.19,26.334z"/>
                            </g>
                        </svg>`;
                break;
            default:
                console.warn('Unknown mask shape selected:', value);
                return ''; // or a default SVG
        }
    
        // Encode the SVG to Base64 and create a Data URL
        const svgBase64 = btoa(svg);
        return `data:image/svg+xml;base64,${svgBase64}`;
    };

  return (
      <Popover
          placement="left-start"
          className='vayu_blocks_toolspanel_items_popover'
          anchor={maskPopoverAnchor}
          onClose={() => setismaskVisible(false)}
          offset={35}
          resize
      >
          <VStack  style={{padding:'10px',
              width: '280px'}}>
                <Text>
              <h4>{__('Mask Shape','vayu-blocks')}</h4>
              <p>{__('Select a mask shape for your element.','vayu-blocks')}</p>
              </Text>
              <Text><HStack className='vayu-blocks-ihover-main'>
                <Text
                    className={`vayu-blocks-ihover-main-panel ${!animationData?.mask?.maskshape || animationData?.mask?.maskshape === 'none' ? 'none-selected' : ''} `}
                    onClick={() => handleMaskAnimationClick('none')} // Update the animation value when clicked
                    title="None"
                >
                    <div className={`vayu-blocks-panel-ihover vayu-blocks-none-button vayu_blocks_none`} >
                    </div>
                </Text>

                <Text
                    className={`vayu-blocks-ihover-main-panel vayu_blocks_rotate_image_compoents_button ${animationData?.mask?.maskshape === 'circle' ? 'selected' : ''}`}
                    onClick={() => handleMaskAnimationClick('circle')} // Update the animation value when clicked
                    title="Circle"
                >
    
                    <div  style={{ maskImage: `url(${getmaskImagePath('circle')})` }}  className={`vayu-blocks-panel-ihover`}></div>

                </Text>

                <Text
                    className={`vayu-blocks-ihover-main-panel ${animationData?.mask?.maskshape === 'diamond' ? 'selected' : ''}`}
                    onClick={() => handleMaskAnimationClick('diamond')} // Update the animation value when clicked
                    title="Diamond"
                >
                    <div style={{ maskImage: `url(${getmaskImagePath('diamond')})` }} className={`vayu-blocks-panel-ihover `}/>
                </Text>

                <Text
                    className={`vayu-blocks-ihover-main-panel ${animationData?.mask?.maskshape === 'hexagone' ? 'selected' : ''}`}
                    onClick={() => handleMaskAnimationClick('hexagone')} // Update the animation value when clicked
                    title="Hexagone"
                    >
                    <div style={{ maskImage: `url(${getmaskImagePath('hexagone')})` }} className={`vayu-blocks-panel-ihover `}/>
                </Text>

                <Text
                    className={`vayu-blocks-ihover-main-panel ${animationData?.mask?.maskshape === 'rounded' ? 'selected' : ''}`}
                    onClick={() => handleMaskAnimationClick('rounded')} // Update the animation value when clicked
                    title="Rounded"
                >
                        <div style={{ maskImage: `url(${getmaskImagePath('rounded')})` }} className={`vayu-blocks-panel-ihover `}/>
                </Text>

                <Text
                    className={`vayu-blocks-ihover-main-panel ${animationData?.mask?.maskshape === 'bob1' ? 'selected' : ''}`}
                    onClick={() => handleMaskAnimationClick('bob1')} // Update the animation value when clicked
                    title="Bob 1"
                >
                        <div style={{ maskImage: `url(${getmaskImagePath('bob1')})` }} className={`vayu-blocks-panel-ihover `}/>
                </Text>

                <Text
                    className={`vayu-blocks-ihover-main-panel ${animationData?.mask?.maskshape === 'bob2' ? 'selected' : ''}`}
                    onClick={() => handleMaskAnimationClick('bob2')} // Update the animation value when clicked
                    title="Bob 2"
                >
                        <div style={{ maskImage: `url(${getmaskImagePath('bob2')})` }} className={`vayu-blocks-panel-ihover `}/>
                </Text>

                <Text
                    className={`vayu-blocks-ihover-main-panel ${animationData?.mask?.maskshape === 'bob3' ? 'selected' : ''}`}
                    onClick={() => handleMaskAnimationClick('bob3')} // Update the animation value when clicked
                    title="Bob 3"
                >
                        <div style={{ maskImage: `url(${getmaskImagePath('bob3')})` }} className={`vayu-blocks-panel-ihover `}/>
                </Text>

                <Text
                    className={`vayu-blocks-ihover-main-panel ${animationData?.mask?.maskshape === 'bob4' ? 'selected' : ''}`}
                    onClick={() => handleMaskAnimationClick('bob4')} // Update the animation value when clicked
                    title="Bob 4"
                >
                        <div style={{ maskImage: `url(${getmaskImagePath('bob4')})` }} className={`vayu-blocks-panel-ihover `}/>
                </Text>
            </HStack></Text>
          
          <Text>
          {animationData?.mask?.maskshape!=='none' && (
          <div className='vayu_block_mask_shape_panel'>
              <ControlPanelControl
                  label={ __( 'Mask Settings', 'vayu-blocks' ) }
              >
                  <SelectControl
                      label={__('Mask size', 'vayu-blocks')}
                      __nextHasNoMarginBottom
                      value={animationData?.mask?.masksize}
                      options={[
                          { label: __('Auto', 'vayu-blocks'), value: 'auto' },
                          { label: __('Contain', 'vayu-blocks'), value: 'contain' },
                          { label: __('Cover', 'vayu-blocks'), value: 'cover' },
                      ]}
                      onChange={(value) => handleMaskAnimationSize(value)}
                  />
                  <br/>
                  <SelectControl
                      label={__('Mask Position', 'vayu-blocks')}
                      __nextHasNoMarginBottom
                      value={animationData?.mask?.maskposition}
                      options={[
                          { label: __('Center Top', 'vayu-blocks'), value: 'center top' },
                          { label: __('Center Center', 'vayu-blocks'), value: 'center center' },
                          { label: __('Center Bottom', 'vayu-blocks'), value: 'center bottom' },
                          { label: __('Left Top', 'vayu-blocks'), value: 'left top' },
                          { label: __('Left Center', 'vayu-blocks'), value: 'left center' },
                          { label: __('Left Right', 'vayu-blocks'), value: 'left right' },
                          { label: __('Right Top', 'vayu-blocks'), value: 'right top' },
                          { label: __('Right Center', 'vayu-blocks'), value: 'right center' },
                          { label: __('Right Right', 'vayu-blocks'), value: 'right right' },
                      ]}
                      onChange={(value) => handleMaskAnimationPosition( value)}
                  />
                  <br/>
                  <SelectControl
                      label={__('Mask Repeat', 'vayu-blocks')}
                      __nextHasNoMarginBottom
                      value={animationData?.mask?.maskrepeat}
                      options={[
                          { label: __('No Repeat', 'vayu-blocks'), value: 'no-repeat' },
                          { label: __('Repeat', 'vayu-blocks'), value: 'repeat' },
                          { label: __('Repeat-X', 'vayu-blocks'), value: 'repeat-x' },
                          { label: __('Repeat-Y', 'vayu-blocks'), value: 'repeat-y' },
                      ]}
                      onChange={(value) => handleMaskAnimationRepeat(value)}
                  />

              </ControlPanelControl>
              </div>
          )}</Text>
          </VStack>
      </Popover>
  )
}

export const MaskPanel = ({
    animationData,
    setmaskPopoverAnchor,
    ismaskVisible,
    togglemaskVisible,
    dataKey, onChange
}) => {

    const handleMaskAnimationClick = (animation) => {
        const updatedAnimationData = {
            ...animationData,
            mask: { ...animationData.mask, maskshape: animation },
        };
        onChange(dataKey, updatedAnimationData);
    };

    const selectedmaskEffect = mask_shapeoptions.find(opt => opt.value === animationData?.mask?.maskshape)?.label || '';

    const getmaskImagePath = (value) => {
        let svg;
        
        switch (value) {
            case 'circle':
                svg = `<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 480 380" xml:space="preserve">
                            <circle cx="240" cy="190" r="184"/>
                        </svg>`;
                break;
            case 'diamond':
                svg = `<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 480 380" xml:space="preserve">
                            <rect x="106.001" y="56.001" transform="matrix(-0.7071 -0.7071 0.7071 -0.7071 275.3553 494.0559)" width="267.998" height="267.999"/>
                        </svg>`;
                break;
            case 'hexagone':
                svg = `<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 480 380" xml:space="preserve">
                            <polygon points="79.386,97.269 240,4.538 400.614,97.269 400.614,282.73 240,375.462 79.386,282.73"/>
                        </svg>`;
                break;
            case 'rounded':
                svg = `<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 480 380" xml:space="preserve">
                            <path d="M421,309.436C421,343.437,393.437,371,359.436,371H120.564C86.563,371,59,343.437,59,309.436V70.564  
                                    C59,36.563,86.563,9,120.564,9h238.871C393.437,9,421,36.563,421,70.564V309.436z"/>
                        </svg>`;
                break;
            case 'bob1':
                svg = `<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 480 380" xml:space="preserve">
                            <path d="M47.846,184.442c-87.942,134.709,80.073,196.702,186.331,196.702c104.494,0,222.582-39.417,222.582-160.557  
                                    C456.758-91.25,198.783-46.776,47.846,184.442z"/>
                        </svg>`;
                break;
            case 'bob2':
                svg = `<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 480 380" xml:space="preserve">
                            <path d="M393.879,31.896c96.935,41.811,41.553,265.103-29.118,320.414c-74.443,58.259-320.428,32.36-330.586-185.032  
                                    C29.551,68.561,183.588-58.822,393.879,31.896z"/>
                        </svg>`;
                break;
            case 'bob3':
                svg = `<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 480 380" xml:space="preserve">
                            <path d="M141.699,9.958c37.611-41.211,253.977,90.988,263.995,181.115c10.016,90.134-215.692,232.896-280.453,172.106
                                    C69.045,310.428,39.531,121.932,141.699,9.958z"/>
                        </svg>`;
                break;
            case 'bob4':
                svg = `<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 480 380" xml:space="preserve">
                            <g>
                                <path d="M69.19,26.334C54.496,39.876,42.91,57.185,35.302,75.221c-10.718,25.408-15.268,52.962-18.384,80.363
                                        c-10.069,88.57,17.375,190.72,112.557,217.96c63.844,18.273,133.074-0.437,191.492-27.517
                                        c85.828-39.789,206.786-163.646,105.685-255.719C372.3,40.81,284.499,59.485,220.248,32.528
                                        c-30.103-12.63-58.445-35.896-92.778-33.125C105.078,1.21,85.272,11.517,69.19,26.334z"/>
                            </g>
                        </svg>`;
                break;
            default:
                console.warn('Unknown mask shape selected:', value);
                return ''; // or a default SVG
        }
    
        // Encode the SVG to Base64 and create a Data URL
        const svgBase64 = btoa(svg);
        return `data:image/svg+xml;base64,${svgBase64}`;
    };

    return (
        <ToolsPanelItem
            className="vayu_blocks_animation_toolspanel_item"
            hasValue={() => !!animationData?.mask?.maskshape}
            label={__('Mask', 'vayu-blocks')}
            onDeselect={() => handleMaskAnimationClick('none')}
            isShownByDefault
        >
            <Button
                ref={setmaskPopoverAnchor}
                onClick={togglemaskVisible}
                className={`block-editor-panel-animation-settings__dropdown ${ismaskVisible ? 'is-open' : ''}`}
            >
                <HStack alignment="left">
                    {!animationData.mask.maskshape || animationData.mask.maskshape === 'none' ? (
                        <div className={`vayu-blocks-panel-ihover vayu-blocks-none-button toolaspanel-size-none-button vayu_blocks_none`} ></div>
                    ) : (
                        <div
                            style={{ maskImage: `url(${getmaskImagePath(animationData.mask.maskshape)})` }}
                            className="vayu_blocks_hstack_animation_panel_image vayu_blocks_hstack_animation_panel_image_color"
                        />
                    )}
                    <Text>
                        {__(
                            !animationData?.mask?.maskshape || animationData?.mask?.maskshape === 'none'
                                ? 'Mask'
                                : selectedmaskEffect
                        )}
                    </Text>
                </HStack>
            </Button>
        </ToolsPanelItem>
    );
};

